
export const findUs = () => {

	let locationSearchButton = document.getElementById('location-search');
	let locationSearchInput = document.querySelector('.find-us__newsletter-input input[name="location-search"]');

	if (locationSearchButton && locationSearchInput) {
	    locationSearchButton.addEventListener('click', function() {
	        
	        let address = locationSearchInput.value;
			let encodedAddress = encodeURIComponent(address);
			window.location.href = '/locations?address=' + encodedAddress;
	    
	    });
	}
}
